export default __webpack_public_path__ + "static/media/logoLL.a20a1d6c.png";